import * as _ from 'lodash'
import store from '@/store'

class Group {
    id = 0

    identifier = 'id'

    mission_id = 0

    settings = {
        visible: false,
        icon: 'marker-blue',
        collapsed: false,
    }

    object_name = 'Group'

    location_gids = []

    get(name) {
        return this[name]
    }

    set(values) {
        _.forEach(values, (v, k) => {
            if (values[k] !== undefined) {
                this[k] = values[k]
            }
        })
    }

    getIcon() {
        return this.getSetting('icon')
    }

    getSetting(property) {
        return this.get('settings')[property]
    }

    setVisible(value) {
        this.updateSettingQueued('visible', value)
    }

    setIcon(value) {
        this.updateSettingQueued('icon', value)
    }

    updateSettingQueued(property, value) {
        this.settings[property] = value
        store.dispatch('mission/updateMissionSettingsQueued', {
            missionId: this.get('mission_id'),
            key: `${this.get('object_name')}_${this.get('id')}`,
            property,
            value,
        })
    }

    isVisible() {
        return this.getSetting('visible')
    }

    isCollapsed() {
        return this.getSetting('collapsed')
    }

    setCollapsed(value) {
        this.updateSettingQueued('collapsed', value)
    }
}

export default Group
